import script from "./Commission.vue?vue&type=script&setup=true&lang=js"
export * from "./Commission.vue?vue&type=script&setup=true&lang=js"

import "./Commission.vue?vue&type=style&index=0&id=0f676b04&lang=css"

const __exports__ = script;

export default __exports__